import React from "react";

const Accueil = () => {
  return (
    <section
      id="accueil"
      className="h-screen bg-cover bg-center relative flex justify-center items-center"
      style={{
        backgroundImage: "url('/images/moi.jpg')",
      }}
    >
      {/* Overlay pour flouter l'image */}
      <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>

      <div className="relative  text-center text-white">
        <h1 className="text-6xl font-bold mb-4">Reich Bella</h1>
        <p className="text-2xl mb-8">Développeur Web Full Stack</p>

        <a
          href="#apropos"
          className="inline-block bg-[#03224C] text-white py-2 px-6 rounded-full text-lg font-semibold hover:bg-blue-600 transition duration-300"
        >
          Qui suis-je ?
        </a>
      </div>
    </section>
  );
};

export default Accueil;
